import React, { useEffect, useState } from "react";
import orgInfo from "../../services/orgInfo";
import OrganizationChart from "../../components/graphs/orgChart/OrgChart";
import { RipplingUserInfo } from "../../types";
import { useLocation } from "react-router-dom";
import ripplingService from "../../services/rippling";

const AVTXOrgChart = () => {
  // State to hold organization chart data
  const [orgChartData, setOrgChartData] = useState<RipplingUserInfo[]>([]);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // Function to flatten hierarchy
  function flattenHierarchy(getParent, employees) {
    const hierarchy = [];

    function findSubordinates(managerId) {
      const subordinates = employees.filter(
        (profile) => profile.manager === managerId
      );

      subordinates.forEach((subordinate) => {
        if (subordinate.title === getParent.title && getParent.name === subordinate.name) {
          subordinate.parentId = "";
        } else {
          subordinate.parentId = subordinate.manager;
        }
        hierarchy.push(subordinate);
        findSubordinates(subordinate.id);
      });
    }

    findSubordinates(getParent.id);
    hierarchy.push(getParent);
    return hierarchy;
  }

  // Function to fetch and process organization chart data
  const load = async () => {
    try {
      // Fetch data from rippling endpoint
      const ripplingResponse = await ripplingService.ripplingEmployees();

      // Check for errors in response
      if (!ripplingResponse.error) {
        const queryName = queryParams.get("name")?.toLowerCase();
        const queryTitle = queryParams.get("title")?.toLowerCase();

        // Find parent based on query parameters
        const getParent = ripplingResponse.data.find((parent) => {
          const parentName =
            `${parent.firstName} ${parent.lastName}`.toLowerCase();
          const parentTitle = parent.title.toLowerCase();
          return (
            parentName.includes(queryName) && parentTitle.includes(queryTitle)
          );
        });

        // Process data based on existence of parent
        const processedData = getParent?.id
          ? flattenHierarchy(getParent, ripplingResponse.data)
          : ripplingResponse.data.map((profile) => {
            profile.parentId =
              profile.title === "Chief Executive Officer"
                ? ""
                : profile.manager;
            return profile;
          });

        // Set the processed data to state
        setOrgChartData(processedData);
      } else {
        // Handle error if any of the responses have an error
        window.snakAlert.error("Error from rippling");
      }
    } catch (error) {
      // Handle any unexpected errors
      console.error("Error while loading org chart data:", error);
    }
  };

  // Load data on initial component render
  useEffect(() => {
    load();
  }, []);

  // Render organization chart component if data is available
  return orgChartData.length ? <OrganizationChart data={orgChartData} /> : null;
};

export default AVTXOrgChart;
